import React, { useContext, useReducer } from 'react';

const StateContext = React.createContext();
const DispatchContext = React.createContext();

const galleryReducer = (state, action) => {
	switch (action.type) {
		case 'next':
			if(state.index >= state.images.length-1) return state;
			return { ...state, index: state.index + 1 };
		case 'prev':
			if(state.index === 0) return state
			return { ...state, index: state.index - 1 };
		case 'openIndex':
			return { ...state, index: action.payload, open:true };
		case 'close':
			return { ...state, open:false };
	}
};

export function GalleryContextProvider({ children, images }) {
	const [ state, dispatch ] = useReducer(galleryReducer, {images, index:0, open:false});
	return (
		<DispatchContext.Provider value={dispatch}>
			<StateContext.Provider value={state}>{children}</StateContext.Provider>
		</DispatchContext.Provider>
	);
}

export const useOpenIndex = () => {
	const dispatch = useContext(DispatchContext);
	return (index) => dispatch({ type: 'openIndex', payload: index });
};

export const useNext = () => {
	const dispatch = useContext(DispatchContext);
	return ()=>dispatch({ type: 'next' });
};

export const usePrev = () => {
	const dispatch = useContext(DispatchContext);
	return ()=>dispatch({ type: 'prev' });
};

export const useClose = () => {
	const dispatch = useContext(DispatchContext);
	return ()=>dispatch({ type: 'close' });
};

export const useHasPrev = () => {
	const state = useContext(StateContext);
	const { index } = state;
	return index <= 0 ? false : true;
};

export const useHasNext = () => {
	const state = useContext(StateContext);
	const { index, images } = state;
	return index >= images.length - 1 ? false : true;
};

export const useImage = () => {
	const { index, images, open } = useContext(StateContext);
	return open ? images[index] : undefined;
};

// export const useIsOpen = () => {
// 	const { open } = useContext(StateContext);
// 	return open;
// };
